import AdminForm from "features/admin/AdminForm";
import React, { useEffect, useState } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import {
  addFilter,
  selectFilter,
  setFilter,
  setLoading,
} from "../filtersAdminSlice";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: "absolute",
      width: "50%",
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  })
);

export type FilterModalType = {
  open: boolean;
  id: string;
};
interface Props {
  props: FilterModalType;
  setModalProps: (e: FilterModalType) => void;
}
const AddFilter: React.FC<Props> = ({ props, setModalProps }) => {
  const dispatch = useDispatch();
  const [progress, setProgress] = useState(0);
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const filter = useSelector(selectFilter);

  const onSubmit = (data: any) => {
    let currentValues = [...filter.data[0].options];
    const newVal = data[`${filter.data[1].name}`];
    currentValues.push(data[`${filter.data[1].name}`]);
    dispatch(
      addFilter({ id: props.id, values: currentValues }, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
  };

  const handleClose = () => {
    setModalProps({ open: false, id: "" });
    batch(() => {
      dispatch(setFilter(undefined));
      dispatch(setLoading(false));
    });
  };

  return (
    <Modal
      open={props.open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div style={modalStyle} className={classes.paper}>
        <AdminForm
          formTitle="Добавяне на филтър"
          onSubmit={onSubmit}
          field={filter}
          progress={progress}
          inModal={true}
        />
      </div>
    </Modal>
  );
};

export default AddFilter;
